import { normalizeMarketStatus } from '../utils/market';

export default class WebsiteAdChild {
  constructor(data = {}) {
    // v1 children key the link on `newarcHomeId`; v2 tagli are standalone
    // nested websiteAdsV2 ads that carry their own doc `id` (+ `code`). Accept
    // both so `/annunci/${newarcHomeId}` resolves for either source.
    this.newarcHomeId = data.newarcHomeId || data.id || '';
    this.id = data.id || data.newarcHomeId || '';
    this.code = data.code || '';
    this.isArchived = data.isArchived ?? false;
    this.isActive = data.isActive ?? true;
    this.type = data.type || '';
    this.floorArea = data.floorArea || 0;
    this.roomCount = data.roomCount || 0;
    this.baths = data.baths || 0;
    this.floors = data.floors || '';
    this.price = data.price;
    this.image = data.image || '';
    this.display = 1;
    // Commercial status of the taglio (#782): websiteSync may write
    // `market: { status, priceDrop }` on each v2 entry. Absent (every v1
    // child, every doc predating the field) ⇒ 'available'.
    this.marketStatus = normalizeMarketStatus(data.market?.status);
  }

  getTitle() {
    return this.type;
  }

  getPrice() {
    return this.price
      
  }

  getFormattedPrice() {
      return parseInt(this.getPrice()).toLocaleString() + '€';
      
  }
}
